import script from "./LocationPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationPicker.vue?vue&type=script&setup=true&lang=js"

import "./LocationPicker.vue?vue&type=style&index=0&id=59218a72&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59218a72"]])

export default __exports__